import { render, staticRenderFns } from "./PeriodsView.vue?vue&type=template&id=ba05c9b8"
import script from "./PeriodsView.vue?vue&type=script&lang=js"
export * from "./PeriodsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports